export const getMessages = async (apiClient, {sessionId, email}) => {
  return apiClient.post(`/v1/sessions/${sessionId}/messages`, {
    email,
    sessionType: "trustedAdvisor",
  });
};

export const stopMaestroRequest = async (
  apiClient,
  {messageId, sessionId, partialContent, agentTaskId, confirmationId},
  options,
) => {
  const body = {
    messageId,
    sessionId,
    partialContent,
    ...(agentTaskId && {agentTaskId}),
    ...(confirmationId && {confirmationId}),
  };
  return options ?
    apiClient.post("/v1/maestro/stop", body, options) :
    apiClient.post("/v1/maestro/stop", body);
};
